'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

var _datamasterForms = require("datamaster-forms");

var _textOutput = _interopRequireDefault(require("../text-output"));

var _formInputs = require("./../form-inputs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var LockpfostenForm = /*#__PURE__*/function (_BaseForm) {
  _inherits(LockpfostenForm, _BaseForm);

  function LockpfostenForm(props) {
    var _this;

    _classCallCheck(this, LockpfostenForm);

    _this = _possibleConstructorReturn(this, (LockpfostenForm.__proto__ || Object.getPrototypeOf(LockpfostenForm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      lockpfostenNotFound: props.project ? false : true,
      lockpfosten: props.project,
      pfosten: []
    });
    _this.saveLockpfosten = _this.saveLockpfosten.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputMutiSelectChange = _this.handleInputMutiSelectChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LockpfostenForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetch("".concat(_conf.default.api.pfostenApiUrlTemplate(this.props.i18n.language)), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this2.setState(function (prev) {
          prev.pfosten = response;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;

      if (this.state.lockpfostenNotFound) {
        return /*#__PURE__*/_react.default.createElement("p", null, t('Not registered'));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-lockpfosten comp-base-form"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "Lockpfosten",
        className: "form-title"
      }, t('Project data')), !_lodash.default.isEmpty(this.state.lockpfosten) ? /*#__PURE__*/_react.default.createElement(_datamasterForms.ProjectLockpfostenForm, {
        t: t,
        history: this.props.history,
        handleInputChange: this.handleInputChange,
        handleInputMultiSelectChange: this.handleInputMutiSelectChange,
        saveNoteFields: this.saveLockpfosten,
        savePfostenFields: this.saveLockpfosten,
        shared: {
          pfosten: this.state.pfosten
        },
        project: this.state.lockpfosten,
        progress: {
          pfosten: null,
          note: null
        },
        error: {
          pfosten: null,
          note: null
        },
        invalidFields: this.state.form.invalidFields,
        success: {
          pfosten: this.state.success,
          note: this.state.success
        },
        isSaving: {
          pfosten: this.state.isSaving,
          note: this.state.isSaving
        },
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputTextArea: _formInputs.TextareaInput,
        TextOutput: _textOutput.default
      }) : null);
    }
    /**
     *
     * @param event
     * @param fieldName
     * @param newVal
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(event, fieldName, newVal) {
      if (fieldName) {
        this.setState(function (prev) {
          prev.lockpfosten[fieldName] = newVal;
          return prev;
        });
      }

      var target = event.target,
          name = target.name,
          type = target.type;
      var value;
      if (type === 'checkbox') value = target.checked;else if (type === 'select-one') {
        value = _lodash.default.find(this.state[name], ['id', target.value]) || _lodash.default.find(this.state[name], ['id', parseInt(target.value)]);
      } else {
        value = target.value;
      }
      this.setState(function (prev) {
        prev.lockpfosten[name] = value;
        return prev;
      });
    }
    /**
     *
     * @param fieldName
     * @param selectedItems
     */

  }, {
    key: "handleInputMutiSelectChange",
    value: function handleInputMutiSelectChange(fieldName, selectedItems) {
      var selectedIds = Array.from(selectedItems).map(function (option) {
        return parseInt(option);
      }).reduce(function (selected, item) {
        if (selected.indexOf(item) !== -1) return selected;
        selected.push(item);
        return selected;
      }, []);

      var value = _lodash.default.filter(this.state.pfosten, function (object) {
        return selectedIds.indexOf(parseInt(object.id)) > -1;
      });

      this.setState(function (prev) {
        prev.lockpfosten.pfosten = value;
        return prev;
      });
    }
    /**
     *
     * @returns {Promise<Response>}
     */

  }, {
    key: "saveLockpfosten",
    value: function saveLockpfosten() {
      var _this3 = this;

      var project = _lodash.default.cloneDeep(this.state.lockpfosten);

      delete project.farm;
      this.setState({
        isSaving: true
      });
      return fetch(_conf.default.api.lockpfostenAllApiUrlTemplate(this.props.i18n.language, this.props.id), {
        method: 'PUT',
        body: JSON.stringify(project),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updatedProject) {
        _this3.setState(function (prev) {
          prev.form.invalidFields = {
            fields: [],
            details: {}
          }; //Reset general error

          prev.error = undefined;
          prev.isSaving = false;
          prev.success = true;
          prev.lockpfosten = updatedProject;
          return prev;
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this3.setState(function (prev) {
          prev.error = message;
          prev.form = {
            error: message,
            invalidFields: {
              fields: Object.keys(invalidFields),
              details: invalidFields
            }
          };
          prev.success = false;
          prev.isSaving = false;
          return prev;
        });
      });
    }
  }]);

  return LockpfostenForm;
}(_baseForm.default);

var _default = (0, _translate.default)(LockpfostenForm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/lockpfosten/index.js
// module id = 714
// module chunks = 0